import {getToken} from '@shared/helpers/tokenizer.helper';
import {TokenNs} from '@shared/types';

export const getHeaders = (): any => {
    const {accessToken} = getToken() as TokenNs.TokenData;

  return {
    Authorization: `Bearer ${accessToken}`
  };
};
